import React, { useEffect, useState } from 'react';
import { Col, Row, Card, Button } from 'react-bootstrap';
import { MdDescription } from 'react-icons/md';
import { useHistory, useParams } from 'react-router-dom';
import { getDocumentById, putDocument } from '../../services/requests';
import FileDocumentPreview from '../../Components/FileDocumentPreview';
import { useStateValue } from '../../providers/StateProvider';
import { actionTypes } from '../../store/reducer';
import { shouldShowFileDocumentPreview } from '../../utils/filePreview';
import { sanitizeHtml } from '../../utils/sanitizeHtml';

import {
  ContainerMain,
  CardHeader,
  Box,
  CardIcon,
  Title,
  CardFooterCustom,
  ButtonCancel,
  ButtonSave,
  ButtonReturn
} from './styles';

type DocumentoSolicitacaoDetalhe = {
  conteudo?: string;
  preview_url?: string;
  verificado_em?: string | null;
  documento_origem?: { assunto?: string };
  solicitacao?: {
    identificador?: string;
  };
};

const DocVisualization = (): JSX.Element => {
  const { id, identificador } = useParams<{ id: string, identificador: string }>();
  const history = useHistory();
  const [, dispatch] = useStateValue();
  const [doc, setDoc] = useState<DocumentoSolicitacaoDetalhe | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const getAllApis = async () => {
    const [documentapi]: any = await Promise.all([
      getDocumentById(id, identificador)
    ]);
    setDoc(documentapi.data);
  };

  const backToSolicitation = () => {
    if (doc?.solicitacao?.identificador) {
      history.push(`/solicitacoes/detalhes/${doc?.solicitacao?.identificador}`);
    } else {
      history.goBack();
    }
  };

  const updateConformidate = async (conformidade: boolean) => {
    if (submitting) {
      return;
    }

    setSubmitting(true);
    try {
      await putDocument(id, conformidade, identificador);
      dispatch({
        type: actionTypes.SET_FLASH_MESSAGE,
        flashMessage: {
          show: true,
          type: 'success',
          title: 'Sucesso',
          message: conformidade
            ? 'Documento aceito com sucesso.'
            : 'Documento recusado com sucesso.',
        },
      });
      backToSolicitation();
    } catch (err: any) {
      const message =
        err?.response?.data?.message ||
        'Não foi possível atualizar a conformidade do documento.';
      dispatch({
        type: actionTypes.SET_FLASH_MESSAGE,
        flashMessage: {
          show: true,
          type: 'error-alt',
          title: 'Erro',
          message,
        },
      });
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    getAllApis();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showFilePreview = shouldShowFileDocumentPreview(
    doc?.conteudo,
    doc?.preview_url,
  );

  return (
    <ContainerMain>
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader>
              <Box>
                <CardIcon>
                  <MdDescription size={20} />
                </CardIcon>
                <Title>{doc?.documento_origem?.assunto}</Title>
              </Box>
              <Button onClick={backToSolicitation}>Voltar</Button>
            </CardHeader>
            <Card.Body>
              {doc && showFilePreview ? (
                <FileDocumentPreview
                  previewUrl={doc.preview_url}
                  conteudo={doc.conteudo}
                  title={doc.documento_origem?.assunto || 'Documento'}
                />
              ) : doc ? (
                <div
                  className="document-html-preview"
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(doc.conteudo || ''),
                  }}
                />
              ) : null}
            </Card.Body>
            <CardFooterCustom>
              {doc && !doc.verificado_em ? (
                <>
                  <ButtonCancel
                    disabled={submitting}
                    onClick={() => { updateConformidate(false); }}
                  >
                    Recusar
                  </ButtonCancel>
                  <ButtonSave
                    disabled={submitting}
                    onClick={() => { updateConformidate(true); }}
                  >
                    Aceitar
                  </ButtonSave>
                </>
              ) : (
                <ButtonReturn onClick={() => { history.goBack() }}>Voltar</ButtonReturn>
              )}
            </CardFooterCustom>
          </Card>
        </Col>
      </Row>
    </ContainerMain>
  );
};

export default DocVisualization;
